import ModalState from './modal';
import SpecialistStore from './specialist';
import Filter from './filter';
import EventsStore from './events';
import OrderFormState from './order-form';
import UserStore from './user';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import ShopStore from './shop';
import FAQStore from './faq';
import LoadingStore from './loading';
import SpecialistOrderFormState from './specialist-order-form';
import FeedbackFormState from './feedback-form';
import SpecialistFilter from './specialist-filter';
import ViewStore from './view';
import CardsStore from './cards';
import KZViewStore from './kz';

const link = createHttpLink({
    uri: '/graphql',
    credentials: 'same-origin'
});

const cache = new InMemoryCache()

class Model {
    constructor() {
        //this.router = new RouteModel(this);
        this.apollo = new ApolloClient({
            link,
            cache: cache,
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'no-cache',
                },
                query: {
                    fetchPolicy: 'no-cache'
                },
                mutate: {
                    fetchPolicy: 'no-cache'
                }
            }
        });
        this.device = { mobile: true };
        this.modal = new ModalState(this);
        this.specialist = new SpecialistStore(this);
        //this.filter = new Filter(this);
        this.events = new EventsStore(this);
        this.orderForm = new OrderFormState(this);
        this.user = new UserStore(this);
        this.shop = new ShopStore(this);
        this.faq = new FAQStore(this);
        this.loading = new LoadingStore(this);
        this.specialistOrderForm = new SpecialistOrderFormState(this);
        this.feedbackForm = new FeedbackFormState(this);
        this.specialistFilter = new SpecialistFilter(this);
        this.view = new ViewStore(this);
        this.cards = new CardsStore(this);
        this.kz = new KZViewStore(this);

        // this.specialist.getSpecialist().then(() => this.events.getEvents());
        // this.shop.getActiveItems();
        // this.user.updateUserInfo();
    }
}

const model = new Model();
window.model = model;
export default model;
